<template>
  <div class="cont">
  <div class="toutu">
    <img src="../../assets/fangweichaxun2023.jpg"></div>
  <div class="div_t">
    <div style="text-align: center;">
	<span style="font-size:18px;">&nbsp;</span><span style="color: rgb(0, 0, 0); font-family: pingfangCg; font-size: 28px; letter-spacing: 10px; text-align: center;">SECURITY CHECK</span></div>
<p class="fwcx" style="overflow-wrap: break-word; margin: 0px 0px 41px; padding: 0px; font-size: 30px; cursor: pointer; color: rgb(0, 0, 0); font-family: pingfangCg; letter-spacing: 6px; text-align: center;">
	防伪查询</p>
<br>
<br>
<div class="fangwei_wrap">
					<input class="fw" type="text" v-model="message" placeholder="请输入防伪码">
					<div class="search_wrap fw_submit" v-on:click="checkcode">
						<img src="../../assets/Search.png">
					</div>
				</div>
<div class="res_text">
					<p class="fw_ts_head"  v-bind:style="{ color: color}">{{fw_ts_head}}</p>
					<p class="fw_ts"  v-bind:style="{ color: color }">{{fw_ts}}</p>
				</div>
<div style="text-align: center;" class="chaxun">
	<span >温馨提示 : 燕铺品牌生产的产品均采用防伪标贴，请认准正品购买。<br>
	刮开防伪图层，输入防伪码即可查询。<br>
	若您的产品查询有问题，请立即致电全国统一客服热线400-852-7856&nbsp;</span></div>
  	<br>
	<br>
	<br>
    <br>
    <br>
  </div>

</div>
</template>

<script>
	
export default {
  name: 'check',
  data () {
    return {
	  message:"",
	  fw_ts_head:"",
	  fw_ts:'',
	  color:"#000"
    }
  },
  created: function () {
	  var self =this
  },
  methods:{
			checkcode:function() {
				this.$http.get('/code.php?code='+this.message).then(function(data){
				if(data.body.status ==1){
					this.color = "#000";
					this.fw_ts_head="";
					this.fw_ts="您购买的是正品";
				}else{
					this.color = "#f00"
					this.fw_ts_head="很遗憾!";
					this.fw_ts="没有查询到该防伪码,请确认是否输入正确";
				};
				},function(res){
				console.log(res);
				});

			}
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;
}
.chaxun{ font-size: 18px;}
.toutu {
    width: 1120px;
    margin: auto;
}
.toutu img {
    width: 100%;
}
.div_t {
    width: 1120px;
    margin: auto;
    margin-top: 84px;
    margin-bottom: 86px;
}
.fangwei_wrap {
    width: 460px;
    height: 56px;
    margin: 0 auto;
    border: 2px solid #ffcb8d;
    border-radius: 5px;
}
.fw {
    width: 390px;
    height: 54px;
    margin-top: 1px;
    border: none;
    margin-left: 2px;
    font-size: 14px;
    padding-left: 10px;
}
.search_wrap {
    width: 58px;
    height: 58px;
    display: inline-block;
    background: #ffcb8d;
    float: right;
}
.search_wrap img {
    width: 40px;
    display: block;
    margin: 8px auto;
}
.post_btn {
				width: 371px;
				height: 52px;
				color: white;
				font-size: 32px;
				text-align: center;
				margin: 102px auto 76px;
				border-radius: 10px;
				line-height: 52px;
				background: #35B497;
			}
			
			.res {
				margin: 21px 31px;
				font-size: 30px;
			}
			
			.res_text {
				font-size: 20px;
				width: 100%;
				height: 186px;
				text-align: center;
				background: white;
			}
			
			.res_text p {
				margin-top: 40px;
			}
			
			.tips {
				text-align: center;
			}
			
			.tips p {
				line-height: 38px;
			}
			
			.tips p:first-child {
				font-size: 24px;
			}
			
			.tips p:not(:first-child) {
				font-size: 19px;
			}
			
			.fwcx {
				font-size: 23px;
				text-align: center;
				margin-bottom: 41px;
			}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 120%; margin-left: -10%;}
   .div_t{ width: 690px; overflow: hidden;}
.chaxun,.fw,.res_text{ font-size: 28px}
   
}     			

</style>



// WEBPACK FOOTER //
// src/components/check/check.vue